 
 <ngb-alert *ngIf="show ()" [dismissible]="dismiss" [type]="errorType ()" (closed)="clear ()">
    {{ error.message }} 
    <span *ngIf="error.name">[ {{ error.name }} ]</span> 
    <button *ngIf="hasMore ()"
    class="btn  btn-link"
     (click)="showMore ()">More info</button>
 </ngb-alert>